import { get, post, del, put } from '../request';

export async function fetchRegressionAnalysisList(
  { equityfinderService },
  authenticationToken,
  { propertyId, year },
) {
  const url = `${equityfinderService}/equityfinder/property/regressionanalysislist/${propertyId}/${year}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteRegressionAnalysis(
  { equityfinderService },
  authenticationToken,
  { analysisId },
) {
  const url = `${equityfinderService}/equityfinder/property/regressionanalysis/${analysisId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function setRegressionAnalysisActive(
  { equityfinderService },
  authenticationToken,
  { analysisId, propertyId, year },
) {
  const url = `${equityfinderService}/equityfinder/property/regressionanalysis/default`;
  const { body } = await put(authenticationToken, url, {
    analysisID: analysisId,
    propID: propertyId,
    year,
  });
  return body;
}

export async function createRegressionAnalysis(
  { equityfinderService },
  authenticationToken,
  { propertyId, year },
) {
  const url = `${equityfinderService}/equityfinder/property/regressionanalysislist/${propertyId}/${year}`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function fetchRegressionAnalysisPropertyList(
  { equityfinderService },
  authenticationToken,
  { analysisId },
) {
  const url = `${equityfinderService}/equityfinder/property/regressionanalysis/${analysisId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteRegressionAnalysisProperty(
  { equityfinderService },
  authenticationToken,
  { compId },
) {
  const url = `${equityfinderService}/equityfinder/property/regressionanalysis/comp/${compId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchRegressionAnalysisPropertyComp(
  { equityfinderService },
  authenticationToken,
  { propertyId, year },
) {
  const url = `${equityfinderService}/equityfinder/property/${propertyId}/${year}/comparables/propcategory`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function addRegressionAnalysisPropertyComp(
  { equityfinderService },
  authenticationToken,
  { analysisId, propertyList },
) {
  const url = `${equityfinderService}/equityfinder/property/regressionanalysis/${analysisId}/bulk`;
  const { body } = await post(authenticationToken, url, {
    propIDList: propertyList,
  });
  return body;
}

export async function searchRegressionAnalysisPropertyComp(
  { equityfinderService },
  authenticationToken,
  { categoryList, propertyId, year },
) {
  const url = `${equityfinderService}/equityfinder/property/${propertyId}/${year}/regressionpool/category`;
  const { body } = await post(authenticationToken, url, {
    categoryIDList: categoryList,
  });
  return body;
}

export async function fetchRegressionAnalysisRulesetProperty(
  { equityfinderService },
  authenticationToken,
  { categoryList, propertyId, year, rulesetId },
) {
  const url = `${equityfinderService}/equityfinder/property/${propertyId}/${year}/regressionpool/category`;
  const { body } = await post(authenticationToken, url, {
    categoryIDList: categoryList,
    rulesetID: rulesetId,
  });
  return body;
}
